import z from "zod/v4";

export const WorkflowIdList = ["create-experience-workflow"] as const;
export const WorkflowIdSchema = z.string();
export type WorkflowId = z.infer<typeof WorkflowIdSchema>;
